
const getFormatedPrice = (price) =>{
    return price + " MAD";
}

export default getFormatedPrice;